const TURBULENT_REYNOLDS_LIMIT = 2300;

export const calculateDarcyFrictionFactor = (
  reynoldsNumber: number,
  roughness: number,
  innerDiameter: number
) => {
  if (reynoldsNumber <= 0) return 0;
  if (reynoldsNumber <= TURBULENT_REYNOLDS_LIMIT) {
    return 64 / reynoldsNumber;
  }

  const haalandTerm =
    6.9 / reynoldsNumber +
    Math.pow(roughness / innerDiameter / 3.7, 1.11);
  return 1 / Math.pow(-1.8 * Math.log10(haalandTerm), 2);
};

export const getFlowRegime = (reynoldsNumber: number) =>
  reynoldsNumber > TURBULENT_REYNOLDS_LIMIT
    ? "turbulent"
    : "laminar";
